import React from 'react';
import {flushSync} from "react-dom";

import { CardContent, Card, CircularProgress, Typography, Stack, LinearProgress } from "@mui/joy";
import Chip from "@mui/joy/Chip";

// components
import BaseApi from "../../utils/BaseApi";
import CommonForm from "../Common/CommonForm";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import {deleteArrayItemByKeyValue, isObjectEmpty} from "../../utils/misc";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import WarningIcon from '@mui/icons-material/Warning';
import SaveIcon from '@mui/icons-material/Save';
import DoneAllIcon from '@mui/icons-material/DoneAll';


class Checklist extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            checklist: null,
            formFields: null,
            answersCount: 0,
            saved: true,
        };
    }

    async componentDidMount() {
        await this.retrieveChecklist();
    }

    countAnswers(formData){
        let answersCount = 0;
        for (let field of Object.entries(formData)){
            if (field[1] !== undefined && field[1] !== ''){
                answersCount += 1
            }
        }
        return answersCount
    }

    async retrieveChecklist(){
        const url = `checklist/${this.props.id}/`;
        const api = new BaseApi();
        let answersCount = 0;
        let response = await api.get(url, {});
        let formFields = await this.retrieveFormFields(response.data);
        let checklist = response.data
        if (typeof checklist.data !== 'object'){
            checklist.data = JSON.parse(checklist.data)
        }
        for (let field of formFields){
            if (field.type === 'checkbox'){
                answersCount += 1
                checklist.data[field.name] = checklist.data[field.name] === 'true'
            }
        }
        if (!isObjectEmpty(checklist.data)){
            answersCount = this.countAnswers(checklist.data)
        }
        this.setState(
            {
                checklist: checklist,
                answersCount: answersCount,
                formFields: formFields,
                saved: true,
            }
        );
    }

    async retrieveFormFields(checklist){
        const url = `checklist/${this.props.id}/update_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        let formFields = response.data
        if ((checklist.owner.id !== this.context.subscriberObject.id) || checklist.completed){
            formFields = deleteArrayItemByKeyValue(
                formFields,
                'name',
                'submitButton'
            );
        }
        return formFields
    }

    async convert(){
        const url = `checklist/${this.props.id}/convert/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        if (response.status === 200){
            await this.retrieveChecklist()
            if (this.props.callBack){
                await this.props.callBack()
            }
        }
    }

    async processForm(form){
        const url = `checklist/${this.props.id}/`;
        const api = new BaseApi();
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        let response = await api.patch(
            url,
            {
                data: JSON.stringify(formDataObj)
            }
        );
        if (response.status === 200){
            this.setState({
                saved: true,
            })
        }
        return response
    }

    onChecklistChange(event){
        flushSync(() => {})
        let formData = new FormData(
            event.target.form
        );
        let answersCount = this.countAnswers(Object.fromEntries(formData))
        this.setState({
            answersCount: answersCount,
            saved: false,
        })
    }

    render() {
        if (!this.state.checklist || !this.state.formFields ) {
            return (<CircularProgress/>)
        }
        let fieldsCount = this.state.formFields.length
        if (this.state.checklist.owner.id === this.context.subscriberObject.id && !this.state.checklist.completed){
            fieldsCount -= 1
        }
        return(
            <Card
                variant={'plain'}
                size={'sm'}
            >
                <CardContent>
                    <Stack
                        direction={'row'}
                        spacing={2}
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            pb: 2
                        }}
                    >
                        <Stack
                            direction={'row'}
                            spacing={1}
                            sx={{
                                minWidth: '50%'
                            }}
                        >
                            <Typography
                                level={'h4'}
                            >
                                {this.state.checklist.type.title}
                            </Typography>
                            {
                                this.state.saved?
                                    <Chip
                                        color={'success'}
                                        sx={{
                                            mr: 1
                                        }}
                                        startDecorator={<SaveIcon fontSize={'small'}/>}
                                    >
                                        Сохранен
                                    </Chip>:
                                    <Chip
                                        color={'warning'}
                                        sx={{
                                            mr: 1
                                        }}
                                        startDecorator={<WarningIcon fontSize={'small'}/>}
                                    >
                                        Не сохранен
                                    </Chip>
                            }
                        </Stack>
                        <Stack
                            direction={'row'}
                            spacing={1}
                            sx={{
                                flexGrow: 2,
                                flexWrap: 'wrap',
                                alignItems: "center",
                            }}
                            useFlexGap
                        >
                            <LinearProgress
                                size="md"
                                color={this.state.answersCount===fieldsCount?'success':'warning'}
                                determinate
                                value={this.state.answersCount / fieldsCount * 100}
                            />
                            <Typography>
                                {this.state.answersCount} / {fieldsCount}
                            </Typography>
                        </Stack>
                    </Stack>
                    <CommonForm
                        fields={this.state.formFields}
                        object={this.state.checklist.data}
                        processForm={this.processForm.bind(this)}
                        onChange={this.onChecklistChange.bind(this)}
                        processing={(this.state.checklist.owner.id !== this.context.subscriberObject.id) || this.state.checklist.completed}
                    />
                    {
                        this.state.checklist.completed?
                            <Chip
                                color={'success'}
                                sx={{
                                    mr: 1
                                }}
                                startDecorator={<SaveIcon fontSize={'small'}/>}
                            >
                                Завершен {this.state.checklist.completed_on}
                            </Chip>:
                            this.state.saved?
                                this.state.answersCount === fieldsCount?
                                    <CommonCallBackButton
                                        callBack={this.convert.bind(this)}
                                        icon={DoneAllIcon}
                                        label={'Завершить'}
                                        color={'success'}
                                        variant={'solid'}
                                    />:
                                        <Chip
                                        color={'warning'}
                                    >
                                       Ответьте на все вопросы чтобы завершить
                                    </Chip>:
                                <Chip
                                    color={'warning'}
                                >
                                   Сохраните чтобы завершить
                                </Chip>
                    }
                </CardContent>
            </Card>
        )
    }
}

export default Checklist